export const extractAndCleanNoteContent = (content: string) => {
    const jsonPattern = /<!--\s*({.*?})\s*-->/;
    const match = content.match(jsonPattern);
    let newMetaData = null;
    let newDoCopyPasteWithMarkdown = false;

    if (match && match[1]) {
        newMetaData = match[0];
        try {
            const jsonContent = JSON.parse(match[1]);
            newDoCopyPasteWithMarkdown = jsonContent?.meta?.copy_paste_markdown || false;
        } catch (error) {
            console.error("Error parsing JSON from note content: ", error);
        }
        content = content.replace(jsonPattern, '');
    }

    return { cleanedContent: content, newMetaData, newDoCopyPasteWithMarkdown };
};

export interface SoapContent {
    [key: string]: {
        value: string;
    };
}

interface ValueWithExists {
    value: string | null;
    exists: boolean;
}

interface ValueWithUnitAndExists {
    value: number | null;
    exists: boolean;
    unit: string | null;
}

interface VitalSigns {
    temperature: ValueWithUnitAndExists;
    heart_rate: ValueWithUnitAndExists;
    respiratory_rate: ValueWithUnitAndExists;
    weight: ValueWithUnitAndExists;
    bcs: ValueWithExists;
}

export interface MetadataSchema {
    animal_name: ValueWithExists;
    sex: ValueWithExists;
    breed: ValueWithExists;
    animal_type: ValueWithExists;
    caregiver_name: ValueWithExists;
    pet_age: ValueWithExists;
    owner_name: ValueWithExists;
    sterilization_status: ValueWithExists;
    vital_signs: VitalSigns;
}

export interface DentalTooth {
    ToothNumber: string;
    DescriptiveToothIdentifier: string;
    Condition: string;
    Procedure: string;
}

export interface DentalData {
    Teeth: DentalTooth[];
    Notes: string;
}

export interface SoapData {
    soap?: SoapContent;
    nervex_soap?: SoapContent;
    take_home_output?: SoapContent;
    english_soap?: SoapContent;
    soap_note?: SoapContent;
    todays_soap?: SoapContent;
    clinical_note?: SoapContent;
    todays_report?: SoapContent;
    meta?: { [key: string]: any };
    organization_name?: string;
    metadata?: MetadataSchema;
    dental?: DentalData;
}

/** Returns true if a petData field value is valid for display (not null, "null", empty, etc.) */
export const isValidFieldValue = (value: string | number | null | undefined): value is string | number => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed !== '' && trimmed.toLowerCase() !== 'null';
    }
    return true;
};

export const safeJsonParse = (content: string): SoapData | null => {
    // If content is empty or not a string, return null
    if (!content || typeof content !== 'string') {
        return null;
    }
    
    // Simple check if content looks like JSON (starts with { and ends with })
    if (!content.trim().startsWith('{') || !content.trim().endsWith('}')) {
        console.warn('Content does not appear to be valid JSON format');
        return null;
    }
    
    try {
        return JSON.parse(content);
    } catch (error) {
        console.error('Error parsing JSON:', error);
        return null;
    }
};